import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Instagram } from '@components/instagram/models';
import { FlowboxComponent } from '@shared/components/flowbox';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-instagram',
  imports: [TitleComponent, FlowboxComponent],
  templateUrl: './instagram.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstagramComponent extends AbstractDynamicComponent<Instagram> {}
